import React from 'react';
import { Select, Avatar, message } from 'antd';
import { workwiseServices } from '../../../../api';
import defaultProfileImage from '../../../../assets/defult-profile-logo.png';

/**
 * Async user-search multi-select. Shared by the Create Pad drawer and the
 * Sync-local-document modal. Requires connectivity (calls getAllSuggestion).
 */
export default function PeopleSelect({ value, onChange, placeholder, disabled }) {
  const [options, setOptions] = React.useState([]);
  const [fetching, setFetching] = React.useState(false);

  const fetchSuggestions = React.useMemo(
    () =>
      async (search) => {
        if (!search) {
          setOptions([]);
          return;
        }
        setFetching(true);
        try {
          const payload = {
            notRequired: [],
            pageNo: 1,
            pageSize: 20,
            referenceId: '00000000-0000-0000-0000-000000000000',
            removeSelf: true,
            search,
            types: [1],
          };
          const res = await workwiseServices.getAllSuggestion(payload);
          const data = res?.data?.data || [];
          setOptions(
            data.map((member) => ({
              value: member.id,
              label: member.name,
              meta: member,
            }))
          );
        } catch (e) {
          message.error('Failed to load suggestions');
        } finally {
          setFetching(false);
        }
      },
    []
  );

  // Debounce typing
  const debouncedSearch = React.useMemo(() => {
    let t;
    return (q) => {
      clearTimeout(t);
      t = setTimeout(() => fetchSuggestions(q), 300);
    };
  }, [fetchSuggestions]);

  return (
    <Select
      mode="multiple"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      showSearch
      labelInValue={false}
      filterOption={false}
      onSearch={debouncedSearch}
      notFoundContent={fetching ? 'Searching…' : 'Type to search users'}
      disabled={disabled}
      optionLabelProp="label"
      style={{ width: '100%' }}
    >
      {options.map((opt) => (
        <Select.Option key={opt.value} value={opt.value} label={opt.label}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Avatar size="small" src={opt.meta?.image || defaultProfileImage} />
            <div>
              <div style={{ fontWeight: 500 }}>{opt.label}</div>
              {opt.meta?.designation && (
                <div style={{ fontSize: 12, color: '#6b7280' }}>{opt.meta.designation}</div>
              )}
            </div>
          </div>
        </Select.Option>
      ))}
    </Select>
  );
}
